import React from "react";
import { NavLink } from "react-router-dom";
import { GsdStandaloneModuleSubNav, useI18n } from "@/coquille-bridge";

export function mapDocumentsPreuvesItemsToTabs(items) {
  return items.map((item) => ({
    id: item.testId,
    segment: item.segment ?? "",
    labelFr: item.labelFr,
    labelEn: item.labelEn,
    testId: item.testId,
    status: "active",
  }));
}

export function renderDocumentsPreuvesNavLink(tab, { className, children, href, disabled }) {
  if (disabled) {
    return (
      <span key={tab.id} className={className} aria-disabled="true" data-testid={tab.testId}>
        {children}
      </span>
    );
  }
  const segment = tab.segment ?? "";
  return (
    <NavLink
      key={tab.id}
      to={href}
      end={!segment}
      className={({ isActive }) =>
        `${className}${isActive ? " gsd-standalone-module-subnav__link--active" : ""}`
      }
      data-testid={tab.testId}
    >
      {children}
    </NavLink>
  );
}

export function DocumentsPreuvesSubNav({ basePath, items, testId = "documents-preuves-subnav" }) {
  const { lang } = useI18n();
  const locale = lang === "en" ? "en" : "fr";

  return (
    <GsdStandaloneModuleSubNav
      basePath={basePath}
      tabs={mapDocumentsPreuvesItemsToTabs(items)}
      lang={locale}
      testId={testId}
      ariaLabelFr="Module Documents & Preuves"
      ariaLabelEn="Documents & Evidence module"
      renderTabLink={renderDocumentsPreuvesNavLink}
    />
  );
}
